import React from 'react';
import { TextField } from './TextField';
import { EmailField } from './EmailField';
import { SelectField } from './SelectField';
import { CheckboxField } from './CheckboxField';
import { DateField } from './DateField';
import { TimeField } from './TimeField';
import { RutField } from './RutField';
import type { Form } from '../../interfaces/form.interface';
import type { Metadata } from '../../interfaces/metadata.interface';

interface FieldFactoryProps {
  meta: Metadata;
  index: number;
  configuration: Form;
}

export const FieldFactory: React.FC<FieldFactoryProps> = ({ meta, index, configuration }) => {
  switch (meta.type) {
    case 'text':
      return <TextField meta={meta} index={index} configuration={configuration} />;
    case 'email':
      return <EmailField meta={meta} index={index} configuration={configuration} />;
    case 'select':
      return <SelectField meta={meta} index={index} configuration={configuration} />;
    case 'checkbox':
      return <CheckboxField meta={meta} index={index} configuration={configuration} />;
    case 'date':
      return <DateField meta={meta} index={index} configuration={configuration} />;
    case 'time':
      return <TimeField meta={meta} index={index} configuration={configuration} />;
    case 'rut':
      return <RutField meta={meta} index={index} configuration={configuration} />;
    default:
      return <TextField meta={meta} index={index} configuration={configuration} />;
  }
}; 